"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toTextWithImageSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toTextWithImageSlice = function (data, logger) {
    var _a, _b, _c, _d, _e;
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.TextWithImage)), { image: logger.required(fields_1.toImage((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.image, logger)), imagePosition: logger.required(logger.toConstValue((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.imagePosition, {
            Gauche: 'left',
            Droite: 'right'
        })), floatText: logger.required(fields_1.toRichText((_c = data === null || data === void 0 ? void 0 : data.primary) === null || _c === void 0 ? void 0 : _c.floatText, logger)), topText: fields_1.toRichText((_d = data === null || data === void 0 ? void 0 : data.primary) === null || _d === void 0 ? void 0 : _d.topText, logger), bottomText: fields_1.toRichText((_e = data === null || data === void 0 ? void 0 : data.primary) === null || _e === void 0 ? void 0 : _e.bottomText, logger) }));
};
exports.toTextWithImageSlice = toTextWithImageSlice;
//# sourceMappingURL=text-with-image-slice.js.map